import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';

const PreCheckoutModal = ({ open, onClose, onConfirm, loading }) => {
  const [nom, setNom] = useState('');
  const [prenom, setPrenom] = useState('');
  const [email, setEmail] = useState('');
  const [telephone, setTelephone] = useState('');

  useEffect(() => {
    if (open) {
      try {
        const user = JSON.parse(localStorage.getItem('user') || '{}');
        if (user.email) setEmail(user.email);
        if (user.name) {
          const parts = user.name.split(' ');
          if (parts.length >= 2) {
            setPrenom(parts[0]);
            setNom(parts.slice(1).join(' '));
          } else {
            setPrenom(user.name);
          }
        }
        if (user.phone || user.telephone) setTelephone(user.phone || user.telephone || '');
      } catch {}
    }
  }, [open]);

  if (!open) return null;

  const isValid = nom.trim() && prenom.trim() && email.trim() && telephone.trim();

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
      background: 'rgba(0,0,0,0.5)', zIndex: 9999,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: '1rem'
    }} onClick={onClose}>
      <div style={{
        background: 'var(--bg-card, #fff)', borderRadius: '16px', padding: '2rem',
        maxWidth: '440px', width: '100%', position: 'relative'
      }} onClick={e => e.stopPropagation()}>
        <button onClick={onClose} style={{
          position: 'absolute', top: '1rem', right: '1rem',
          background: 'none', border: 'none', cursor: 'pointer'
        }}><X size={20} /></button>

        <h3 style={{ fontSize: '1.2rem', fontWeight: 700, marginBottom: '0.5rem' }}>
          Vos informations
        </h3>
        <p style={{ fontSize: '0.85rem', color: 'var(--text-muted)', marginBottom: '1.5rem' }}>
          Ces informations sont necessaires pour creer votre espace candidat.
        </p>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.75rem' }}>
            <div>
              <label style={{ display: 'block', fontSize: '0.8rem', fontWeight: 600, marginBottom: '0.3rem' }}>
                Prenom <span style={{ color: '#DC2626' }}>*</span>
              </label>
              <input
                data-testid="checkout-prenom"
                type="text" value={prenom} onChange={e => setPrenom(e.target.value)}
                placeholder="Marie"
                style={{
                  width: '100%', padding: '0.65rem 0.75rem', borderRadius: '8px',
                  border: '2px solid var(--border-primary)', background: 'var(--bg-card)', fontSize: '0.9rem'
                }}
              />
            </div>
            <div>
              <label style={{ display: 'block', fontSize: '0.8rem', fontWeight: 600, marginBottom: '0.3rem' }}>
                Nom <span style={{ color: '#DC2626' }}>*</span>
              </label>
              <input
                data-testid="checkout-nom"
                type="text" value={nom} onChange={e => setNom(e.target.value)}
                placeholder="Dupont"
                style={{
                  width: '100%', padding: '0.65rem 0.75rem', borderRadius: '8px',
                  border: '2px solid var(--border-primary)', background: 'var(--bg-card)', fontSize: '0.9rem'
                }}
              />
            </div>
          </div>

          <div>
            <label style={{ display: 'block', fontSize: '0.8rem', fontWeight: 600, marginBottom: '0.3rem' }}>
              Email <span style={{ color: '#DC2626' }}>*</span>
            </label>
            <input
              data-testid="checkout-email"
              type="email" value={email} onChange={e => setEmail(e.target.value)}
              placeholder="marie.dupont@gmail.com"
              style={{
                width: '100%', padding: '0.65rem 0.75rem', borderRadius: '8px',
                border: '2px solid var(--border-primary)', background: 'var(--bg-card)', fontSize: '0.9rem'
              }}
            />
          </div>

          <div>
            <label style={{ display: 'block', fontSize: '0.8rem', fontWeight: 600, marginBottom: '0.3rem' }}>
              Telephone <span style={{ color: '#DC2626' }}>*</span>
            </label>
            <input
              data-testid="checkout-telephone"
              type="tel" value={telephone} onChange={e => setTelephone(e.target.value)}
              placeholder="06 12 34 56 78"
              style={{
                width: '100%', padding: '0.65rem 0.75rem', borderRadius: '8px',
                border: `2px solid ${!telephone.trim() ? '#fca5a5' : 'var(--border-primary)'}`,
                background: 'var(--bg-card)', fontSize: '0.9rem'
              }}
            />
          </div>
        </div>

        <button
          data-testid="checkout-confirm-btn"
          onClick={() => onConfirm({ nom: nom.trim(), prenom: prenom.trim(), email: email.trim(), telephone: telephone.trim() })}
          disabled={!isValid || loading}
          style={{
            width: '100%', marginTop: '1.5rem', padding: '0.85rem',
            borderRadius: '10px', border: 'none', cursor: isValid && !loading ? 'pointer' : 'not-allowed',
            background: isValid ? '#E75480' : '#ccc', color: '#fff',
            fontWeight: 700, fontSize: '0.95rem'
          }}
        >
          {loading ? 'Redirection vers le paiement...' : 'Continuer vers le paiement'}
        </button>
      </div>
    </div>
  );
};

export default PreCheckoutModal;
